const country = [
  { nome: "Todos os países", codigo: "" },
  { nome: "Brasil", codigo: "brasil" },
  { nome: "Paraguai", codigo: "paraguai" },
];

export default country;
